import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import UserPrefsContext from "../../context/UserPrefs/UserPrefsContext";
import EVIncentives from "./../../components/EVIncentives/EVIncentives";
import EVJumbotron from "./../../components/EVJumbotron/EVJumbotron";
import ChargingMap from "./../../components/LocationMap/ChargingMap";
import CostOfOwnership from "./../../components/CostOfOwnership/CostOfOwnership";
import getPaymentDetails from "./../../functions/vehicle/getPaymentDetails";

import LoadingSpinner from "./../../components/LoadingSpinner/LoadingSpinner";
import isPHEV from "../../functions/vehicle/isPHEV";
import { FormatCarName } from "../../utils/Helpers/Format";

const EV = ({
  electricVehicles,
  electricVehiclesLoading,
  userLocation,
  ip,
  uuid,
}) => {
  const userPrefs = useContext(UserPrefsContext);
  const { evId } = useParams();

  let car = null;
  let paymentDetails = {};

  if (electricVehicles) {
    const currentEvId = (evId || "").toString();
    car = electricVehicles.find((ev) => ev.handle === currentEvId);
    paymentDetails = getPaymentDetails(
      car,
      userPrefs
    );
  }

  useEffect(() => {
    document.title = car
      ? `${FormatCarName(car)}`
      : "";
  });
  const ignoreSuperchargerStations = car && isPHEV(car);

  const renderEV = car && !electricVehiclesLoading ? (
    <>
      <EVJumbotron
        car={car}
        incentives={car.incentives}
        paymentDetails={paymentDetails}
      />
      <CostOfOwnership cars={[car, car.equivalent_gas_vehicle]} />
      <EVIncentives incentives={car.incentives} car={car} />
      <section className="container-fluid charging-map">
        <section className="container">
          <ChargingMap
            userLocation={userLocation}
            ignoreSuperchargerStations={ignoreSuperchargerStations}
            hideList={true}
          />
        </section>
      </section>
    </>
  ) : (
    <div className="container text-center">
      <LoadingSpinner />
    </div>
  );


  return (
    <>
     { renderEV }
    </>
  );
};

export default EV;

EV.propTypes = {
  electricVehicles: PropTypes.array,
  electricVehiclesLoading: PropTypes.bool,
  userLocation: PropTypes.object,
  ip: PropTypes.string,
  uuid: PropTypes.string
};
